var _line, _line2, _line3, _line4, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTransports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 24.587,
    y1: 14.253,
    x2: 38.58,
    y2: 14.253,
    style: {
      strokeDasharray: "0 3"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.206,
    y1: 24.616,
    x2: 19.25,
    y2: 17.384
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.628,
    y1: 27.747,
    x2: 38.58,
    y2: 27.747
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.043,
    y1: 27.747,
    x2: 25.453,
    y2: 27.747
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.42,
    y1: 27.747,
    x2: 9.868,
    y2: 27.747
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.456,
    cy: 27.747,
    r: 3.587
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.041,
    cy: 27.747,
    r: 3.587
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14.253,
    r: 3.587
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTransports);
export default __webpack_public_path__ + "static/media/indoor-transports.6858565b9ef6b5e91a1cf07d703cad9f.svg";
export { ForwardRef as ReactComponent };